import InviteTeamMemberFinished from '@Pages/inviteTeamMember/InviteTeamMemberFinished/InviteTeamMemberFinished';
import { rootRoute } from './rootRoute';

import { beforeLoadGeneral } from '@Router/middleware';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { createRoute } from '@tanstack/react-router';
import AdminPersonalDetails from '@Pages/inviteTeamMember/AdminPersonalDetails/AdminPersonalDetails';
import InviteTeamMemberIntro from '@Pages/inviteTeamMember/InviteTeamMemberIntro/InviteTeamMemberIntro';
import AccountantPersonalDetails from '@Pages/inviteTeamMember/AccountantPersonalDetails/AccountantPersonalDetails';
import { VerifyPhone } from '@Pages/inviteTeamMember/VerifyPhone/VerifyPhone';
import { SetPassword } from '@Pages/inviteTeamMember/SetPassword/SetPassword';

const inviteTeamMemberIntroRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.INVITE_TEAM_MEMBER_INTRO].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.INVITE_TEAM_MEMBER_INTRO,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <InviteTeamMemberIntro />,
});

const inviteAccountantFormRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.INVITE_ACCOUNTANT_FORM].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.INVITE_ACCOUNTANT_FORM,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <AccountantPersonalDetails />,
});

const verifyPhoneNumberRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.VERIFY_PHONE_NUMBER].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.VERIFY_PHONE_NUMBER,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <VerifyPhone />,
});

const setPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.SET_PASSWORD].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.SET_PASSWORD,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <SetPassword />,
});

const inviteTeamMemberFinishedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.INVITE_TEAM_MEMBER_FINISHED].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.INVITE_TEAM_MEMBER_FINISHED,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <InviteTeamMemberFinished />,
});

const inviteAdminFormRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.INVITE_ADMIN_FORM].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.INVITE_ADMIN_FORM,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    });
  },
  component: () => <AdminPersonalDetails />,
});

export const inviteTeamMemberRoutes = [
  inviteTeamMemberIntroRoute,
  inviteAccountantFormRoute,
  verifyPhoneNumberRoute,
  setPasswordRoute,
  inviteTeamMemberFinishedRoute,
  inviteAdminFormRoute,
];
